import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveProjectStatusNotificationState = createStateReducer(
  initialState,
  {
    [events.removeProjectStatusSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeProjectStatus",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.removeProjectStatusFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeProjectStatus",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceRemoveProjectStatusNotificationState };
